/* CARBO_LAUNCH Bedarf – progressive Storefront-Optimierungen ohne Lieferregel-Duplikate */
(() => {
  'use strict';

  const normalize = (value = '') => value
    .toLocaleLowerCase('de-DE')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const findInformationContainer = (heading, root) => {
    let node = heading.parentElement;
    while (node && node !== root) {
      if (node.tagName === 'SECTION' || node.tagName === 'ARTICLE' || node.classList.contains('tp-ups__section')) return node;
      node = node.parentElement;
    }
    return null;
  };

  const convertSectionToDetails = (heading, root) => {
    const container = findInformationContainer(heading, root);
    if (!container || container.dataset.tpCompactDetails === 'true') return;
    if (container.querySelector(':scope > .tp-ups__compact-details')) return;
    const headingText = heading.textContent.trim();
    if (!headingText) return;

    container.dataset.tpCompactDetails = 'true';
    const accessibleHeading = heading.cloneNode(true);
    accessibleHeading.removeAttribute('id');
    accessibleHeading.className = 'tp-visually-hidden';
    const details = document.createElement('details');
    details.className = 'tp-ups__compact-details';
    const summary = document.createElement('summary');
    summary.textContent = headingText;
    const content = document.createElement('div');
    content.className = 'tp-ups__compact-details-content';
    heading.remove();
    Array.from(container.children)
      .filter((child) => child !== accessibleHeading && child !== details && !['SCRIPT', 'STYLE'].includes(child.tagName))
      .forEach((child) => content.append(child));
    details.append(summary, content);
    container.prepend(accessibleHeading);
    container.append(details);
  };

  const enhanceProductInformation = (scope = document) => {
    const pageRoot = scope.querySelector?.('#MainContent[data-template*="product"]')
      || (scope.matches?.('#MainContent[data-template*="product"]') ? scope : null);
    if (!pageRoot) return;
    const root = pageRoot.querySelector('.tp-ups, [data-tp-product-universal]');
    if (!root) return;
    root.classList.add('tp-ups--optimized');
    const targets = ['technische daten', 'produkteigenschaften', 'trockeneis sicher verwenden', 'sicherheit und handhabung', 'sicherheitshinweise'];
    root.querySelectorAll('h2, h3').forEach((heading) => {
      const title = normalize(heading.textContent);
      if (targets.some((target) => title.includes(normalize(target)))) convertSectionToDetails(heading, root);
    });
  };

  const enhanceB2BFormAnchor = (scope = document) => {
    const currentAnchorId = 'B2BForm-tp_b2b_static';
    const legacyAnchorId = 'B2BForm-tp_b2b_fBRt4d';
    const form = scope.querySelector?.(`#${currentAnchorId}`) || document.getElementById(currentAnchorId);
    if (!form) return;
    let legacyAnchor = document.getElementById(legacyAnchorId);
    if (!legacyAnchor) {
      legacyAnchor = document.createElement('span');
      legacyAnchor.id = legacyAnchorId;
      legacyAnchor.className = 'tp-b2b-form-anchor-alias';
      legacyAnchor.setAttribute('aria-hidden', 'true');
      legacyAnchor.style.cssText = 'display:block;height:0;scroll-margin-top:120px;';
      form.insertAdjacentElement('beforebegin', legacyAnchor);
    }
    document.querySelectorAll(`a[href$="#${legacyAnchorId}"]`).forEach((link) => {
      try {
        const url = new URL(link.href, window.location.href);
        url.hash = currentAnchorId;
        link.href = `${url.pathname}${url.search}${url.hash}`;
      } catch (error) {
        link.setAttribute('href', `#${currentAnchorId}`);
      }
    });
    if (window.location.hash === `#${legacyAnchorId}`) window.requestAnimationFrame(() => form.scrollIntoView({ block: 'start' }));
  };

  const friendlyCustomerCopy = (value = '') => String(value)
    .replace(/\bV20\s+EXPRESSFENSTER\b/gi, 'Expressversand')
    .replace(/\bNächster\s+zentraler\s+Cut[\s-]?off\b/gi, 'Nächster Bestellschluss')
    .replace(/\bder\s+zentrale\s+Express-Cut[\s-]?off\b/gi, 'der Bestellschluss für Expressversand')
    .replace(/\bden\s+zentralen\s+V20-Lieferregeln\b/gi, 'unseren aktuellen Lieferregeln')
    .replace(/\bnach\s+den\s+zentralen\s+V20-Regeln\b/gi, 'nach unseren Lieferregeln')
    .replace(/\bmit\s+den\s+zentralen\s+V20-Regeln\b/gi, 'mit unseren Lieferregeln')
    .replace(/\bderselben\s+V20-Logik\b/gi, 'denselben Lieferregeln')
    .replace(/\bzentralen\s+V20-Bestellschluss\b/gi, 'Bestellschluss für Expressversand')
    .replace(/\bV20-Lieferkorridors\b/gi, 'Lieferzeitraums')
    .replace(/\bV20-Lieferkorridor\b/gi, 'Lieferzeitraum')
    .replace(/\bV20-Bestellschluss\b/gi, 'Bestellschluss')
    .replace(/\bV20-Regeln\b/gi, 'Lieferregeln')
    .replace(/\bV20-Logik\b/gi, 'Lieferlogik')
    .replace(/\bCut[\s-]?off:\s*(\d{1,2}:\d{2})(?!\s*Uhr)/gi, 'Bestellschluss: $1 Uhr')
    .replace(/\bCut[\s-]?off\b/gi, 'Bestellschluss');

  const patchCustomerCopy = (scope = document) => {
    const root = scope instanceof Node ? scope : document;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((node) => {
      const parent = node.parentElement;
      if (!parent || ['SCRIPT', 'STYLE', 'TEMPLATE', 'NOSCRIPT'].includes(parent.tagName)) return;
      const next = friendlyCustomerCopy(node.nodeValue || '');
      if (next !== node.nodeValue) node.nodeValue = next;
    });

    if (root instanceof Element) {
      [root, ...root.querySelectorAll('[title], [aria-label]')].forEach((element) => {
        ['title', 'aria-label'].forEach((attribute) => {
          if (!element.hasAttribute(attribute)) return;
          const current = element.getAttribute(attribute) || '';
          const next = friendlyCustomerCopy(current);
          if (next !== current) element.setAttribute(attribute, next);
        });
      });
    } else {
      document.querySelectorAll('[title], [aria-label]').forEach((element) => {
        ['title', 'aria-label'].forEach((attribute) => {
          if (!element.hasAttribute(attribute)) return;
          const current = element.getAttribute(attribute) || '';
          const next = friendlyCustomerCopy(current);
          if (next !== current) element.setAttribute(attribute, next);
        });
      });
    }
  };

  const initialize = (scope = document) => {
    enhanceProductInformation(scope);
    enhanceB2BFormAnchor(scope);
    patchCustomerCopy(scope);
  };

  const observeCustomerCopy = () => {
    if (!document.documentElement || document.documentElement.dataset.tpCustomerCopyObserver === 'true') return;
    document.documentElement.dataset.tpCustomerCopyObserver = 'true';
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const parent = node.parentElement;
            if (!parent || ['SCRIPT', 'STYLE', 'TEMPLATE', 'NOSCRIPT'].includes(parent.tagName)) return;
            const next = friendlyCustomerCopy(node.nodeValue || '');
            if (next !== node.nodeValue) node.nodeValue = next;
          } else if (node instanceof Element) {
            patchCustomerCopy(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialize(document);
      observeCustomerCopy();
    }, { once: true });
  } else {
    initialize(document);
    observeCustomerCopy();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
